import React from "react";
import '../styles/logos.scss';
import { StaticImage } from "gatsby-plugin-image";

import SectionHeader from './section-header';
import Coat from '../assets/clients/logos/coat-logo.svg';
import Tala from '../assets/clients/logos/tala-logo.svg';
import TillySveaas from '../assets/clients/logos/tilly-sveaas-logo.svg';
import Cambridge from '../assets/clients/logos/cambridge-satchel-co-logo.svg';
import EdgeOfEmber from '../assets/clients/logos/edge-of-ember-logo.svg';
import AstleyClarke from '../assets/clients/logos/astley-clarke-logo.svg';
import BeyondNine from '../assets/clients/logos/beyond-nine-logo.svg';
import MerciMaman from '../assets/clients/logos/merci-maman-logo.svg';
import WeAreRiley from '../assets/clients/logos/we-are-riley-logo.svg';
import PlankHardware from '../assets/clients/logos/plank-hardware-logo.svg';
import Seep from '../assets/clients/logos/seep-logo.svg';
import StoriesAndInk from '../assets/clients/logos/stories-and-ink-logo.svg';

// StaticImage needs a literal src, so each raster logo gets its own component.
const imageProps = { objectFit: 'contain', placeholder: 'none', width: 400 };
const Bedfolk = ({ style }) => <StaticImage src="../assets/clients/logos/bedfolk-logo.png" alt="Bedfolk" style={style} {...imageProps} />;
const Underdays = ({ style }) => <StaticImage src="../assets/clients/logos/underdays-logo.png" alt="Underdays" style={style} {...imageProps} />;
const Jubel = ({ style }) => <StaticImage src="../assets/clients/logos/jubel-logo.png" alt="Jubel" style={style} {...imageProps} />;

// ratio = logo width / height. Used to give every logo a similar visual weight.
// scale = optional nudge for logos that read lighter or heavier than their size suggests.
const clients = [
    { name: 'Jubel', Logo: Jubel, ratio: 1.38 },
    { name: 'COAT', Logo: Coat, ratio: 3.5 },
    { name: 'TALA', Logo: Tala, ratio: 4 },
    { name: 'Tilly Sveaas', Logo: TillySveaas, ratio: 11 },
    { name: 'The Cambridge Satchel Company', Logo: Cambridge, ratio: 5.6 },
    { name: 'Edge of Ember', Logo: EdgeOfEmber, ratio: 10.4 },
    { name: 'Bedfolk', Logo: Bedfolk, ratio: 4.74 },
    { name: 'Astley Clarke', Logo: AstleyClarke, ratio: 8.8 },
    { name: 'Underdays', Logo: Underdays, ratio: 0.89 },
    { name: 'Beyond Nine', Logo: BeyondNine, ratio: 2.6 },
    { name: 'Merci Maman', Logo: MerciMaman, ratio: 2.9, scale: 1.2 },
    { name: 'We Are Riley', Logo: WeAreRiley, ratio: 2.08 },
    { name: 'Plank Hardware', Logo: PlankHardware, ratio: 2.64 },
    { name: 'Seep', Logo: Seep, ratio: 0.8 },
    { name: 'Stories & Ink', Logo: StoriesAndInk, ratio: 6.65 },
];

// Cells are 2:1. Size each logo to a constant area, capped to 90% of the cell width and 80% of its height.
const AREA = 0.16;
const MAX_WIDTH = 0.9;
const MAX_HEIGHT = 0.4;
const logoWidth = (ratio, scale = 1) => Math.min(MAX_WIDTH, Math.sqrt(AREA * ratio) * scale, MAX_HEIGHT * ratio) * 100;

const Logos = () => {
    return (
        <section className="ff logos">
            <SectionHeader heading="Trusted globally" />
            <ul className="ff grid">
                {clients.map(({ name, Logo, ratio, scale }) => (
                    <li key={name} className="logo">
                        <Logo
                            style={{ width: `${logoWidth(ratio, scale).toFixed(1)}%`, aspectRatio: ratio }}
                            role="img"
                            aria-label={name}
                        />
                    </li>
                ))}
            </ul>
        </section>
    )
}

export default Logos
